export default __webpack_public_path__ + "static/media/cart4.fe58a027.svg";